import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { HttpService, API, Title, toast, Messages, swal, Spinner } from '../../../config/react'
import DataTable from 'react-data-table-component'

function Settings(props) {
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [SettingOptions, setSettingOptions] = useState([])
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [SearchTerm, setSearchTerm] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const columns = [
    {
      name: 'Title',
      sortable: true,
      sortField: 'hj_title',
      selector: (row) => row.hj_title
    },
    {
      name: 'Key',
      sortable: true,
      sortField: 'hj_key',
      selector: (row) => row.hj_key
    },
    {
      name: 'Value',
      selector: (row) => row.hj_value
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/system/settings/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteOption(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    setIsAuth(true)
    GetSettingOptions()
    document.title = Title.Settings
  }, [CustomFilters, SearchTerm])

  const GetSettingOptions = () => {
    const passData = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetSettingAdminOptions, passData).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];

        setSettingOptions(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_row)
      }
    })
  }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }
  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Title, Key, Value."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })

  const DeleteOption = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteSettingOption, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetSettingOptions()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Settings} </h3>
        <div className="btn-group">
          <Link
            to="/system/settings/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Option{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={SettingOptions}
                  // progressPending={loading}
                  pagination
                  paginationServer
                  persistTableHead={true}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  progressPending={loading}
                  paginationDefaultPage={currentPage}
                  progressComponent={<Spinner />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Settings
